import React, { useState, useEffect } from 'react';
import __ from "localisation";
import ProgressTabs from "components/ProgressTabs";
import Create from './Create';
import Source from './Source';
import { LoadingBox } from 'components/LoadingIndicators';
import useTabs from 'hooks/useTabs';
import { useTransactions } from 'queries/transactions';
import middleman from 'helpers/middleman';

const pageTabs = [
  'init',
  'sources'
];

const Deposit = ({ match }) => {
  const { portfolioUuid } = match.params;
  const [selected, setSelected] = useState(1);
  const [transaction, setTransaction] = useState(false);
  const [portfolio, setPortfolio] = useState(false);

  useTabs(setSelected, selected, window.location.hash, pageTabs);
  const { data: transactions, isLoading: transactionsLoading } = useTransactions(portfolioUuid, 'draft');

  const init = async () => {
    const res = await middleman.get(`/portfolio/${portfolioUuid}`).then(response => response.data);
    setPortfolio(res);
  };

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (transactionsLoading) {
      setTransaction(false);
    }
    if (!transactionsLoading && transactions && transactions.length > 0) {
      const lastTransaction = transactions[0];
      setTransaction(lastTransaction);
    }
  }, [transactions, transactionsLoading]);


  if (transactionsLoading || !portfolio) {
    return (
      <LoadingBox />
    );
  }


  const tabs = [
    {
      component: Create,
      title: `1.${__('new_deposit')}`,
      time: 1,
      forceRender: false,
      componentProps: {
        setTransaction,
        setSelected,
        transaction,
        portfolioUuid,
        transactionsLoading,
      }
    },
    {
      component: Source,
      title: `2.${__('sources')}`,
      time: 1,
      forceRender: false,
      componentProps: {
        transaction,
        portfolioUuid,
      }
    }
  ];

  return (
    <>
      <ProgressTabs
        selected={selected}
        setSelected={setSelected}
        tabs={tabs}
        noButton
      />
    </>
  );

};

export default Deposit;
